<template>
  <div class="expected-title">
    <h1>{{ expectedText.heading }}</h1>
    <p class="expected-sub-text">
      We don’t expect you to take on too many support projects, but we do expect
      you to help out where you can. If you haven’t engaged with any businesses
      in a while, we might get in touch to see how things are going and if
      there’s anything we can do to help.
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      expectedText: {
        heading: "What's expected of me?",
      },
    };
  },
};
</script>
<style>
.expected-title h1 {
  padding-top: 20px;
  font-weight: 500;
  margin: auto;
  color: black;
  font-size: 2.188rem;
  line-height: 3.125rem;
  margin-top: 30px;
}
.expected-sub-text {
  font-size: 1rem;
  margin-top: 30px;
  font-weight: 400;
  line-height: 1.5rem;
}
</style>
